import React, { useState } from 'react';
import Button from '@mui/material/Button';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

const DeleteModal = ({ open, handleDailogClose, handleDelete }) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleDailogClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        sx={{ '& .MuiDialog-paper': { width: '500px', height: 'auto' } }}
      >
        <DialogTitle id='alert-dialog-title'>
          <h2 style={{margin:0, fontSize:'1.3rem'}}>Delete</h2>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{ fontSize: '0.85rem!important' }}
          >
            Are you sure you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            pr: 4,
            pb: 3,
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={handleDailogClose}
            color='primary'
            variant='contained'
            sx={{ ml: 1.8, backgroundColor: '#BE1E2E' }}
          >
            CANCEL
          </Button>
          <Button
            onClick={handleDelete}
            color='primary'
            autoFocus
            variant='contained'
            sx={{ mr: 1.8 }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteModal;
